export const USE_TEST_RECAPTCHA = false

export const RECAPTCHA_SITE_KEY = USE_TEST_RECAPTCHA  ? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" : "6LdGmswtAAAAAJfUwQXJCjMpvy55BEyYwf9-cUsL"

export const RECAPTCHA_SIZE = USE_TEST_RECAPTCHA ? "normal" : "invisible"

export const RECAPTCHA_REQUIRED_MESSAGE = "Будь ласка, підтвердіть, що ви не робот"
